import React from 'react';
import { FadeIn } from './FadeIn';
export function Problem() {
  return <section className="py-20 px-6" data-id="element-166">
      <div className="max-w-3xl mx-auto" data-id="element-167">
        <FadeIn data-id="element-168">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-8 text-center" data-id="element-169">
            El "Interruptor del Cortisol"
          </h2>
          <div className="space-y-6 font-sans text-lg text-charcoal/80 leading-relaxed" data-id="element-170">
            <p data-id="element-171">
              A partir de los 40 años, tu bioquímica ya no responde a las
              calorías de la misma forma. El estrés crónico, las noches de mal
              sueño y los cambios en los estrógenos mantienen encendido el{' '}
              <strong className="text-charcoal" data-id="element-172">
                "Interruptor del Cortisol"
              </strong>
              .
            </p>
            <p data-id="element-173">
              Cuando este interruptor está activado, tu cuerpo entra en modo
              supervivencia. Envía cada carbohidrato directamente a la grasa
              abdominal para protegerse de una amenaza que no existe.
            </p>
            <p className="bg-sage/10 p-6 rounded-xl border border-sage/20 text-charcoal font-medium" data-id="element-174">
              Por eso te sientes hinchada al final del día y agotada antes de
              las 4 de la tarde. No es grasa común; es inflamación hormonal.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}